import {
  BaseListItem,
  listItemStyles
} from "./chunk.LBF6MTVU.js";
import {
  emit
} from "./chunk.HM4ZRC4T.js";
import {
  focusVisibleSelector
} from "./chunk.ZX7YPA4S.js";
import {
  watch
} from "./chunk.HBM5K2JV.js";
import {
  __decorateClass
} from "./chunk.U4VUMZVF.js";

// src/components/list-item/list-item.ts
import { html } from "lit";
import { customElement, property } from "lit/decorators.js";

// src/components/list-item/list-item.styles.ts
import { css } from "lit";
var list_item_styles_default = css`
	${listItemStyles}

	.list-item:not(.list-item--single-selectable.list-item--checked, .list-item--locked, .list-item--disabled) .list-item__label {
		color: var(--yotpo-font-color-light-primary);
	}

	.list-item:not(.list-item--single-selectable.list-item--checked, .list-item--locked, .list-item--disabled)
		.list-item__sublabel {
		color: var(--yotpo-font-color-light-secondary);
	}

	.list-item__label-wrapper {
		display: flex;
		align-items: center;
		column-gap: var(--yotpo-spacing-small);
	}

	.list-item.list-item--disabled:not(.list-item--single-selectable.list-item--checked, .list-item--locked) {
		color: var(--yotpo-color-disabled);
	}

	.list-item--single-selectable.list-item--locked:not(.list-item--disabled, .list-item--checked) {
		color: var(--yotpo-font-color-light-secondary);
	}

	.list-item--single-selectable.list-item--locked:not(.list-item--disabled, .list-item--checked) .list-item__prefix,
	.list-item--single-selectable.list-item--locked:not(.list-item--disabled, .list-item--checked) .list-item__suffix {
		color: var(--yotpo-font-color-light-tertiary);
	}

	:host(:hover:not([aria-disabled='true']))
		.list-item--single-selectable.list-item--locked:not(.list-item--disabled, .list-item--checked),
	:host(${focusVisibleSelector}:not([aria-disabled='true']))
		.list-item--single-selectable.list-item--locked:not(.list-item--disabled, .list-item--checked) {
		background-color: var(--yotpo-color-general-10);
	}
`;

// src/components/list-item/list-item.ts
var LIST_ITEM_LOCKED_CLASS = "list-item--locked";
var YotpoListItem = class extends BaseListItem {
  constructor() {
    super(...arguments);
    this.sublabel = "";
    this.status = "";
    this.locked = false;
    this.tooltipText = "";
  }
  async firstUpdated() {
    super.firstUpdated();
    await this.updateComplete;
    if (this.locked) {
      this.handleLockedChange();
    }
  }
  handleClick(e) {
    if (!this.locked) {
      super.handleClick(e);
    }
  }
  handleLockedChange() {
    if (this.locked) {
      this.listItem.classList.add(LIST_ITEM_LOCKED_CLASS);
    } else {
      this.listItem.classList.remove(LIST_ITEM_LOCKED_CLASS);
    }
  }
  handleTooltipAction(e) {
    e.stopPropagation();
    emit(this, "yotpo-tooltip-action" /* tooltipAction */, { detail: e.detail });
  }
  render() {
    const listItemContent = html`${this.status ? html` <yotpo-dot-indicator status=${this.status} class="list-item__status"></yotpo-dot-indicator>` : html`<span part="prefix" class="list-item__prefix">
						<slot name="prefix"></slot>
				  </span>`}

			<span part="labels" class="list-item__labels yotpo-theme-light">
				<span class="list-item__label-wrapper">
					<span part="label" class="list-item__label yotpo-text-medium"> ${this.label} </span>
					<slot name="label-suffix"></slot>
				</span>
				<span part="sublabel" class="list-item__sublabel yotpo-text-small"> ${this.sublabel} </span>
			</span>`;
    const listItem = this.renderListItem(listItemContent);
    return this.tooltipText ? html`
					<yotpo-tooltip text=${this.tooltipText} @yotpo-tooltip-action=${this.handleTooltipAction}>
						${listItem}
					</yotpo-tooltip>
			  ` : listItem;
  }
};
YotpoListItem.styles = list_item_styles_default;
__decorateClass([
  property({ reflect: true })
], YotpoListItem.prototype, "sublabel", 2);
__decorateClass([
  property()
], YotpoListItem.prototype, "status", 2);
__decorateClass([
  property({ type: Boolean, reflect: true })
], YotpoListItem.prototype, "locked", 2);
__decorateClass([
  property({ reflect: true })
], YotpoListItem.prototype, "tooltipText", 2);
__decorateClass([
  watch("locked", { waitUntilFirstUpdate: true })
], YotpoListItem.prototype, "handleLockedChange", 1);
YotpoListItem = __decorateClass([
  customElement("yotpo-list-item")
], YotpoListItem);

export {
  YotpoListItem
};
